// extracted by mini-css-extract-plugin
export default {"labelUI":"StepsComponent_labelUI__7CRWe","botonCircular":"StepsComponent_botonCircular__6yPHi"};